import { API_URL } from 'core/infra/environment'
import { HttpClient } from 'core/infra/http/HttpClient'
import { LocalStorageClient } from 'core/infra/storage/LocalStorageClient'

import { AgnosticUserRepository } from 'auth/infra/AgnosticUserRepository'
import { createUserRepository } from 'auth/infra/userRepository'

import { createRfpGuideInviteInterceptor } from './createRfpGuideInviteInterceptor'

export function createRfpGuideHttpClient() {
  const storage = new LocalStorageClient()
  const inviteUserRepository = new AgnosticUserRepository({ storage })
  const sessionUserRepository = createUserRepository({ storage })

  return new HttpClient(API_URL, {
    requestInterceptor: createRfpGuideInviteInterceptor({
      inviteUserRepository,
      sessionUserRepository,
    }),
  })
}
